import { render, staticRenderFns } from "./tabKeluargaProfil.vue?vue&type=template&id=407d6c32"
import script from "./tabKeluargaProfil.vue?vue&type=script&lang=js"
export * from "./tabKeluargaProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports